var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationMarkOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15384_56953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.144 5.856C26.336 -1.952 13.664 -1.952 5.856 5.856C-1.952 13.664 -1.952 26.336 5.856 34.144C13.664 41.952 26.336 41.952 34.144 34.144C41.952 26.336 41.952 13.664 34.144 5.856Z",
    fill: "#F95108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2832 28.9392C22.2832 30.1872 21.2379 31.2272 19.9952 31.2272C18.7525 31.2272 17.7072 30.1818 17.7072 28.9392C17.7072 27.6965 18.7152 26.6512 19.9952 26.6512C21.2752 26.6512 22.2832 27.6592 22.2832 28.9392ZM22.1125 10.9925L22.1125 22.5445C22.1125 23.8938 21.1365 24.7685 19.9899 24.7685C18.8432 24.7685 17.8352 23.8938 17.8352 22.5445L17.8352 10.9925C17.8352 9.64317 18.8112 8.76851 19.9899 8.76851C21.1685 8.76851 22.1125 9.64317 22.1125 10.9925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15384_56953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(40 40) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkOrange);
export default __webpack_public_path__ + "static/media/exclamation-mark-orange.fde61cae94d7d5638fa88368a51d7bce.svg";
export { ForwardRef as ReactComponent };